(function () {
  'use strict';

  function pushRouteEvent(eventName, el) {
    if (!eventName || !el) return;

    var context = el.closest('[data-page-type], [data-page-handle]');
    var section = el.closest('[id]');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      route_code: el.getAttribute('data-route-code') || '',
      route_label: el.getAttribute('data-route-label') || '',
      route_family: el.getAttribute('data-route-family') || '',
      destination_type: el.getAttribute('data-destination-type') || '',
      destination_url: el.getAttribute('data-destination-url') || el.getAttribute('href') || '',
      page_type: el.getAttribute('data-page-type') || (context && context.getAttribute('data-page-type')) || document.body.getAttribute('data-page-type') || '',
      page_handle: el.getAttribute('data-page-handle') || (context && context.getAttribute('data-page-handle')) || document.body.getAttribute('data-page-handle') || '',
      section_id: section ? section.id : '',
      source_url: window.location.pathname + window.location.search,
      intent: el.getAttribute('data-intent') || ''
    });
  }

  document.addEventListener('click', function (event) {
    var el = event.target.closest('[data-route-event], [data-bundle-hub-event], [data-bundle-route-event], [data-bundle-continuity-event]');
    if (!el) return;

    var eventName =
      el.getAttribute('data-route-event') ||
      el.getAttribute('data-bundle-hub-event') ||
      el.getAttribute('data-bundle-route-event') ||
      el.getAttribute('data-bundle-continuity-event');

    pushRouteEvent(eventName, el);
  });

  document.addEventListener('toggle', function (event) {
    var el = event.target;
    if (!el || !el.open) return;

    var eventName =
      el.getAttribute('data-route-toggle-event') ||
      el.getAttribute('data-bundle-hub-toggle-event') ||
      el.getAttribute('data-bundle-hub-details-event');

    if (!eventName) return;
    pushRouteEvent(eventName, el);
  }, true);
})();
